export default __webpack_public_path__ + "static/media/ico-forum.751488c8.webp";